import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import connect from "react-redux/es/components/connect";
import translate from "../i18n/translate";
import { actionToggleFooter, actionToggleNavBar, actionToggleSideBar } from "../store/action/LayoutActionSupervisor";
import { client, getQueryVariable, getAccessRightsForPageID, actionGetTranche } from "../store/action/RemoteActionSupervisor";
import { PAGEID, ACCESSRIGHTSTYPE } from "../i18n/constants";
import { getMultiLanguageMessage } from "../i18n/multiLanguage";

let BASE_URL = process.env.REACT_APP_SERVER_URL_API;

const TrancheModify = (props) => {
    const [language, setLanguage] = useState("");
    const [pageAccessRights, setPageAccessRights] = useState({});
    const [selectedTranche, setSelectedTranche] = useState({});
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);

    const updateProcessStatus = async (processStatus) => {
        let confirmMessage = '';
        if (processStatus === 'Verified') {
            confirmMessage = getMultiLanguageMessage('msg_Verify_Confirm', language);
        } else if (processStatus === 'Approved') {
            confirmMessage = getMultiLanguageMessage('msg_Approve_Confirm', language);
        } else if (processStatus === 'Cancelled') {
            confirmMessage = getMultiLanguageMessage('msg_Cancel_Confirm', language);
        } else {
            return;
        }

        if (window.confirm(confirmMessage)) {
            setIsButtonClicked(true);
            let adminId = localStorage.getItem("supervisorid");

            const params = {
                VfaspID: process.env.REACT_APP_VFASP_CODE,
                AdminID: adminId,
                ProcessStatus: processStatus,
                AUTORECID: selectedTranche.AUTORECID,
            };

            await client(localStorage.getItem("supervisortoken")).put(`${BASE_URL}/tranche/processstatus/update`, params).then((response) => {
                if (response.status === 200) {
                    setIsSubmitSuccess(true);
                } else {
                    alert(response.data ? response.data.Message : getMultiLanguageMessage('msg_Server_Error', language));
                    setIsSubmitSuccess(false);
                }
            }).catch(error => {
                alert(getMultiLanguageMessage('msg_Server_Error', language));
                setIsSubmitSuccess(false);
            });
            setIsButtonClicked(false);
        }
    };

    useEffect(() => {
        if (props?.trancheList?.length > 0) {
            setSelectedTranche(props.trancheList[0]);
        }
    }, [props.trancheList]);

    useEffect(() => {
        let selectedLanguage = localStorage.getItem("locale");
        setLanguage(selectedLanguage);
        let accessRights = getAccessRightsForPageID(PAGEID.Tranche);
        setPageAccessRights(accessRights);
        if (accessRights && accessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes) {
            let trancheId = getQueryVariable(window.location.search, "TID");
            if (trancheId && trancheId.length > 0) {
                props.actionGetTranche(trancheId);
            } else {
                alert('Invalid Selection');
            }
        } else {
            alert(getMultiLanguageMessage('Msg_InvalidAccessRights', selectedLanguage));
        }
    }, []);

    return ((props?.supervisor?.length > 0 && pageAccessRights && pageAccessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes && selectedTranche.AUTORECID > 0) ?
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-TrancheModify')}</h2>

            {/* .nav-tabs-line */}
            <div className="tab-content" id="security-opt-tab">
                {/* .tab-pane */}
                <div className="tab-pane active show" id="password-opt">
                    <form action="#">
                        {/* .row */}

                        <table width='100%'>
                            <tbody>
                                <tr>
                                    <td className='td-type2-col1'>{translate('TrancheName')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.TrancheName}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('Token')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.AgathaBalance}&nbsp;AGATHA
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('TrancheRate')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.Rate}&nbsp;{translate('Euro')}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('StartDate')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.StartDate}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('EndDate')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.EndDate}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('FounderReserve')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.FounderReserveQuantity}&nbsp;AGATHA
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('PendingOrders')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.AgathaUsed}&nbsp;AGATHA
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('Bonus')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.AgathaBonus}&nbsp;AGATHA
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('TokenRemaining')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.AgathaRamaining}&nbsp;AGATHA
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('CreatedDate')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.DateCreated}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('CreatedByUser')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.CreatedByUser}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('ProcessStatus')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.ProcessStatus}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('VerifiedDate')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.DateVerified}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('VerifiedByUser')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.VerifiedByUser}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('ApprovedDate')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.DateApproved}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('ApprovedByUser')}</td>
                                    <td className='td-type2-col2'>
                                        {selectedTranche.ApprovedByUser}
                                    </td>
                                </tr>

                            </tbody>
                        </table>

                        {isButtonClicked &&
                            <>
                                <div className="gaps" />
                                <img width={80} src={require('../assets/images/loading.gif')} srcSet={require('../assets/images/loading.gif')} alt="loading" />
                            </>
                        }
                        <div className="gaps-2x" />
                        <div className="d-sm-flex justify-content-between align-items-center">
                            <div className="gaps-2x d-sm-none" />
                            <span className="color-success">
                                {isSubmitSuccess &&
                                    <div>
                                        <em className="ti ti-check-box" /> {translate('Update-Success-Message')}
                                        <div className="gaps-1x" />
                                    </div>
                                }
                            </span>
                        </div>

                        {(!isSubmitSuccess && selectedTranche.ProcessStatus === 'Created' && pageAccessRights.VerifyAccess === ACCESSRIGHTSTYPE.Yes) &&
                            < div className="d-sm-flex">
                                <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => updateProcessStatus('Verified')}>{translate('btnVerify')}</Button>
                                <div style={{ width: '20px' }} />
                                <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => updateProcessStatus('Cancelled')}>{translate('btnCancel')}</Button>
                                <div className="gaps-2x d-sm-none" />
                            </div>
                        }
                        {(!isSubmitSuccess && selectedTranche.ProcessStatus === 'Verified' && pageAccessRights.ApprovalAccess === ACCESSRIGHTSTYPE.Yes) &&
                            < div className="d-sm-flex justify-content-between align-items-center">
                                <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => updateProcessStatus('Approved')}>{translate('btnApprove')}</Button>
                                <div className="gaps-2x d-sm-none" />
                            </div>
                        }
                    </form>
                    {/* form */}
                </div>
                {/* .tab-pane */}
            </div >
            {/* .tab-content */}
        </div >
        : "");
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
        supervisor: state.remote.supervisor,
        trancheList: state.remote.trancheList
    };
};

export default connect(mapStateToProps, {
    actionToggleNavBar,
    actionToggleSideBar,
    actionToggleFooter,
    actionGetTranche
})(TrancheModify);
